import V from "./design-system.es58.js";
import A from "./design-system.es95.js";
import L from "./design-system.es81.js";
import { resolveComponent as m, openBlock as s, createElementBlock as r, createVNode as g, Fragment as y, withDirectives as C, normalizeClass as x, createElementVNode as f, toDisplayString as u, createCommentVNode as p, createTextVNode as a, renderList as S, createBlock as b, withCtx as O, renderSlot as v, vShow as k, withModifiers as B, mergeProps as T } from "vue";
import I from "./design-system.es116.js";
/* empty css                    */
import z from "./design-system.es128.js";
const E = {
  name: "DsMultiselectMenu",
  components: {
    Icon: V,
    Spinner: A,
    MultiSelectMenuItem: L
  },
  props: {
    /**
     * Text displayed on the add option
     */
    addText: String,
    helpText: Boolean,
    allowAdd: Boolean,
    categorized: Boolean,
    categoriesLabel: String,
    multiple: Boolean,
    limit: Number,
    options: {
      type: Array,
      default: () => []
    },
    pointer: Number,
    filter: {
      type: String,
      default: ""
    },
    modelValue: [Object, Array],
    loading: Boolean,
    /**
     * Show blank menu option
     */
    showBlank: Boolean,
    helpTextProp: {
      type: String,
      default: "helpText"
    },
    labelProp: {
      type: String,
      default: "label"
    },
    valueProp: {
      type: String,
      default: "value"
    },
    disabledOptionProp: {
      type: String,
      default: "disabledOption"
    },
    showOptionModifierProp: String,
    /**
     * Disables category selection - for use with multi-level dropdown
     */
    disableCategorySelect: Boolean,
    /**
     * Enables dense menu items
     */
    dense: Boolean,
    /**
     * Text to display where there are no options
     */
    emptyOptionsLabel: String,
    /**
     * Whether to display empty options label (hidden with searchable multiselect, that has no results label)
     */
    showEmptyOptionsLabel: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "add",
    "category-view",
    "category-mouse-over",
    "menu-tem-changed",
    "select-category",
    "update:modelValue",
    "update:pointer",
    "update-visible-options"
  ],
  setup() {
    return { i18n: I() };
  },
  data() {
    return {
      active: !1,
      // So we know which dropdown options to show based on selected category
      activeCategoryIndex: -1,
      // Looking at category page or options
      categoryViewActive: this.categorized,
      closeOnBodyClick: !0,
      localPointer: this.pointer,
      selected: this.modelValue,
      selectedCategory: null
    };
  },
  computed: {
    categoryOptions() {
      let e = [];
      return this.categorized && this.options && (e = this.options.map(({
        category: t,
        options: i,
        groups: n,
        separator: l
      }, o) => ({
        label: t.label,
        value: t.value,
        icon: t.icon,
        separator: !!l,
        index: o,
        hasChildrenOptions: !!(i || n)
      })), this.multiple) ? e.filter((t) => {
        const i = t[this.valueProp], n = this.selected.find(({ value: l }) => l === i);
        return t.hasChildrenOptions || !n;
      }) : e;
    },
    dropdownOptions() {
      let { options: e } = this;
      const t = `${this.filter}`.toLowerCase();
      if (this.categorized)
        if (this.activeCategoryIndex > -1)
          e = this.options[this.activeCategoryIndex].groups ? this.options[this.activeCategoryIndex].groups : this.options[this.activeCategoryIndex].options;
        else
          return [];
      return e.length > 0 && (e = Array.isArray(e[0].options) ? this.filterAndFlattenGroups(e, t) : t ? this.filterOptions(e, t) : e, this.multiple) ? e.filter((n) => {
        const l = n[this.valueProp];
        return !this.selected.find(({ value: o }) => o === l);
      }) : e;
    },
    visibleOptions() {
      return this.categoryViewActive ? this.categoryOptions : this.dropdownOptions;
    }
  },
  watch: {
    categoryViewActive(e) {
      e && (this.activeCategoryIndex = -1), this.$emit("category-view", e);
    },
    localPointer(e) {
      this.$emit("update:pointer", e);
    },
    pointer(e) {
      this.localPointer = e;
    },
    modelValue: {
      handler(e) {
        this.selected = e;
      },
      deep: !0
    },
    visibleOptions: {
      handler() {
        this.updateVisibleOptions();
      },
      deep: !0
    }
  },
  mounted() {
    this.updateVisibleOptions();
  },
  methods: {
    handleMouseOver(e = null, t = null) {
      if (this.localPointer = e, this.categorized && t) {
        const i = this.$refs.category[e];
        this.$emit("category-mouse-over", {
          categoryReference: i,
          optionIndex: e
        });
      }
    },
    add() {
      this.$emit("add");
    },
    arrowBack() {
      this.categorized && !this.categoryViewActive && this.backToCategory();
    },
    arrowForward() {
      this.categorized && this.categoryViewActive && this.selectCategory(this.categoryOptions[this.localPointer]);
    },
    clearSelection() {
      this.selected = null, this.$emit("update:modelValue", this.selected);
    },
    onEnter(e) {
      this.categoryViewActive ? this.selectCategory(e) : this.selectOption(e);
    },
    backToCategory() {
      this.selectedCategory = null, this.categoryViewActive = this.categorized;
    },
    filterAndFlattenGroups(e, t) {
      return e = this.filterGroups(e, t), e = this.flattenGroupOptions(e), e;
    },
    filterGroups(e, t) {
      return e.map(({ options: i, label: n, showLabelWhenEmpty: l }) => {
        const o = this.filterOptions(i, t);
        return o && (o.length || l) ? {
          label: n,
          showLabelWhenEmpty: l,
          options: o
        } : [];
      });
    },
    filterOptions(e, t) {
      return t ? (t = `${t}`.toLowerCase(), e.filter((i) => {
        const n = (i[this.labelProp] ? i[this.labelProp] : "").toLowerCase(), l = (i[this.helpTextProp] ? i[this.helpTextProp] : "").toLowerCase();
        return l.length > 0 && l.includes(t) || n.length > 0 && n.includes(t);
      })) : e;
    },
    flattenGroupOptions(e) {
      return e.reduce((t, i) => {
        const n = i.options ? i.options : [];
        return n.length || i.showLabelWhenEmpty ? (i.label !== !1 && t.push({
          groupLabel: i.label,
          isLabel: !0
        }), t.concat(n)) : t.concat(i);
      }, []);
    },
    selectOption(e) {
      !e.isLabel && !e[this.disabledOptionProp] && (this.multiple ? (!this.limit || this.selected.length < this.limit) && this.selected.push(e) : this.selected = e, this.selectedCategory && this.$emit("select-category", this.selectedCategory), this.$emit("update:modelValue", this.selected));
    },
    selectCategory(e) {
      this.selectedCategory = e, !this.disableCategorySelect && e.hasChildrenOptions ? (this.activeCategoryIndex = e.index, this.categoryViewActive = !1, this.$emit("menu-tem-changed")) : e.hasChildrenOptions || this.selectOption(e);
    },
    updateVisibleOptions() {
      this.$emit("update-visible-options", this.visibleOptions);
    }
  }
}, G = { class: "multiselect-menu" }, N = {
  key: 0,
  class: "menu-loading-container"
}, q = {
  key: 0,
  class: "label dropdown-header"
}, F = ["data-qa"], _ = {
  key: 2,
  class: "label empty-options"
}, D = ["data-qa"], j = {
  key: 3,
  class: "label empty-options"
};
function R(e, t, i, n, l, o) {
  const P = m("Spinner"), w = m("Icon"), h = m("MultiSelectMenuItem");
  return s(), r("div", G, [
    i.loading ? (s(), r("div", N, [
      g(P)
    ])) : (s(), r(y, { key: 1 }, [
      l.categoryViewActive ? C((s(), r("ul", {
        key: "categories",
        class: x([{ dense: i.dense }])
      }, [
        i.categoriesLabel ? (s(), r("li", q, [
          f("label", null, u(i.categoriesLabel), 1)
        ])) : p("", !0),
        t[4] || (t[4] = a()),
        i.allowAdd ? (s(), r("li", {
          key: 1,
          class: "add",
          "data-qa": i.addText,
          onClick: t[0] || (t[0] = (...d) => o.add && o.add(...d))
        }, [
          g(w, { name: "add" }),
          t[3] || (t[3] = a()),
          f("span", null, u(i.addText || n.i18n.messages["select.add"]), 1)
        ], 8, F)) : p("", !0),
        t[5] || (t[5] = a()),
        i.showEmptyOptionsLabel && o.categoryOptions.length === 0 ? (s(), r("li", _, u(i.emptyOptionsLabel || n.i18n.messages["select.empty.options"]), 1)) : p("", !0),
        t[6] || (t[6] = a()),
        (s(!0), r(y, null, S(o.categoryOptions, (d, c) => (s(), b(h, {
          key: c,
          index: c,
          pointer: l.localPointer,
          option: d,
          selected: l.selected,
          filter: i.filter,
          "is-category": "",
          onSelectOption: o.selectCategory,
          onMouseover: o.handleMouseOver
        }, {
          default: O(() => [
            v(e.$slots, "option", {}, void 0, !0)
          ]),
          _: 2
        }, 1032, ["index", "pointer", "option", "selected", "filter", "onSelectOption", "onMouseover"]))), 128))
      ], 2)), [
        [k, i.showEmptyOptionsLabel || o.categoryOptions.length > 0 || i.allowAdd]
      ]) : p("", !0),
      t[13] || (t[13] = a()),
      l.categoryViewActive ? p("", !0) : C((s(), r("ul", {
        key: "options",
        class: x([{ dense: i.dense }])
      }, [
        i.showBlank && !i.multiple && !i.categorized ? (s(), r("li", {
          key: 0,
          onClick: t[1] || (t[1] = B((...d) => o.clearSelection && o.clearSelection(...d), ["prevent", "stop"]))
        }, `
                     
                `)) : p("", !0),
        t[9] || (t[9] = a()),
        l.selectedCategory ? (s(), b(h, {
          key: 1,
          option: l.selectedCategory,
          "is-category": "",
          "is-breadcrumb": "",
          onSelectOption: o.backToCategory
        }, null, 8, ["option", "onSelectOption"])) : p("", !0),
        t[10] || (t[10] = a()),
        i.allowAdd ? (s(), r("li", {
          key: 2,
          class: "add",
          "data-qa": i.addText,
          onClick: t[2] || (t[2] = (...d) => o.add && o.add(...d))
        }, [
          g(w, { name: "add" }),
          t[7] || (t[7] = a()),
          f("span", null, u(i.addText || n.i18n.messages["select.add"]), 1)
        ], 8, D)) : p("", !0),
        t[11] || (t[11] = a()),
        i.showEmptyOptionsLabel && o.dropdownOptions.length === 0 ? (s(), r("li", j, u(i.emptyOptionsLabel || n.i18n.messages["select.empty.options"]), 1)) : p("", !0),
        t[12] || (t[12] = a()),
        (s(!0), r(y, null, S(o.dropdownOptions, (d, c) => (s(), b(h, {
          key: c,
          index: c,
          pointer: l.localPointer,
          option: d,
          selected: l.selected,
          "value-prop": i.valueProp,
          "label-prop": i.labelProp,
          "disabled-option-prop": i.disabledOptionProp,
          "show-option-modifier-prop": i.showOptionModifierProp,
          filter: i.filter,
          "help-text": i.helpText,
          "help-text-prop": i.helpTextProp,
          onSelectOption: o.selectOption,
          onMouseover: o.handleMouseOver
        }, {
          default: O((M) => [
            v(e.$slots, "option", T({ ref_for: !0 }, M), void 0, !0)
          ]),
          optionModifier: O(() => [
            v(e.$slots, "optionModifier", {}, void 0, !0)
          ]),
          _: 2
        }, 1032, ["index", "pointer", "option", "selected", "value-prop", "label-prop", "disabled-option-prop", "show-option-modifier-prop", "filter", "help-text", "help-text-prop", "onSelectOption", "onMouseover"]))), 128))
      ], 2)), [
        [k, i.showEmptyOptionsLabel || o.dropdownOptions.length > 0 || i.allowAdd]
      ])
    ], 64))
  ]);
}
const Y = /* @__PURE__ */ z(E, [["render", R], ["__scopeId", "data-v-a74400e6"]]);
export {
  Y as default
};
//# sourceMappingURL=design-system.es80.js.map
